import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST as string | undefined;

export function initPostHog() {
  if (!POSTHOG_KEY) {
    console.log("[PostHog] No VITE_POSTHOG_KEY configured, skipping initialization");
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST || "https://us.i.posthog.com",
    ui_host: "https://us.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    capture_exceptions: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-ph-mask]",
    },
    loaded(ph) {
      if (import.meta.env.MODE === "development") {
        ph.opt_out_capturing();
        console.log("[PostHog] Development mode — capturing disabled");
      } else {
        console.log(`[PostHog] Initialized for: ${import.meta.env.MODE}`);
      }
    },
  });
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, properties);
}

export function resetUser() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

export function captureEvent(event: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

export function captureException(error: Error, context?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.captureException(error, context);
}

export { posthog };
